export const QUESTIONNAIRE = {
   PUBLISHED_STATUS: 'PUBLICADO',
   DRAFT_STATUS: 'BORRADOR',
   PROGRAMMED_STATUS: 'PROGRAMADO',
   INACTIVE_STATUS: 'INACTIVO'
}

export const PUBLISH_PROGRAMMED_QUEST_CONFIRMATION_QUESTION =
   'Señor usuario, Está intentando publicar un cuestionario que tiene una fecha de programación. ¿Desea  publicar el cuestionario de forma inmediata?'
